import type { WorkflowStageId } from '~/domain/workflow/workflowStages';
import type { CatalogMessageId } from '~/i18n';

/** Name of each workflow stage, as the viewer's step rail shows it. */
export const WORKFLOW_STAGE_LABEL_IDS: Record<
    WorkflowStageId,
    CatalogMessageId
> = {
    setup: 'workflow.setup',
    syntheticImaging: 'workflow.syntheticImaging',
    imageRegistration: 'workflow.imageRegistration',
    contouring: 'workflow.contouring',
    review: 'workflow.review',
    dosePlanning: 'workflow.dose',
    adapt: 'workflow.adapt',
    export: 'workflow.export',
};
